
  import { defineComponent, onMounted, ref } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import * as Yup from 'yup';
  import MonacoEditor from '@guolao/vue-monaco-editor';

  export default defineComponent({
    name: 'newsletter-sections-editing',
    components: {
      ErrorMessage,
      Field,
      Form,
      MonacoEditor,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const route = useRoute();
      const { can } = useAbility();
      const submitButton = ref<HTMLButtonElement | null>(null);

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('newslettersSectionUpdating'), [
          translate('assets'),
        ]);
      });
      const { data } = await store.dispatch(
        Actions.GET_NEWSLETTER,
        route.params.id
      );

      const translate = (text: string) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const goBack = () => {
        router.back();
      };

      const newsletter = ref<any>(data.data);

      const parsedVariables = JSON.parse(newsletter.value.variables);

      const newslettersSchema = Yup.object().shape({
        title: Yup.string()
          .required(() => translate('EN_TITLE_IS_REQUIRED_FIELD'))
          .label('title'),
        key: Yup.string()
          .required(() => translate('EN_KEY_IS_REQUIRED_FIELD'))
          .label('key'),
      });

      const htmlContentPreview = newsletter.value.htmlContent.replace(
        /{{\s*([^}]+)\s*}}/g,
        (_, variable) => parsedVariables[variable.trim()] || ''
      );

      const onSubmitUpdate = async (values) => {
        if (submitButton.value) {
          // eslint-disable-next-line
        submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }
        if (values.sort) {
          values.sort = Number(values.sort);
        }
        const payload = {
          ...values,
          htmlContent: newsletter.value.htmlContent,
        };
        await store.dispatch(Actions.UPDATE_NEWSLETTER, {
          id: route.params.id,
          data: payload,
        });
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          //Deactivate indicator
          submitButton.value?.removeAttribute('data-kt-indicator');
          // eslint-disable-next-line
        submitButton.value!.disabled = false;
        } else {
          Swal.fire({
            text: translate('SUCCESSFULLY_UPDATED_NEWSLETTER_SECTION'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            router.push({ name: 'newsletter-sections-listing' });
          });
        }
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        onSubmitUpdate,
        submitButton,
        translate,
        newslettersSchema,
        goBack,
        newsletter,
        can,
        htmlContentPreview,
      };
    },
  });
